export default __webpack_public_path__ + "static/media/arrow-up.095d1cf3.svg";